module.exports = __webpack_public_path__ + "img/hairsalon1.a44fc8fb.png";